import { axiosInstance } from "../../axios-Instance";
import { getLoginToken } from "../../storage";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "../../react-query/constants";

async function getNewsletter() {
  const data = await axiosInstance({
    url: "/newsletter",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

const createNewsletter = async (formData: any) => {
  const data = await axiosInstance({
    url: "/newsletter",
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

const updateNewsletter = async (formData: any) => {
  const data = await axiosInstance({
    url: `/newsletter/${formData["_id"]}`,
    method: "PUT",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

const deleteNewsletter = async (formData: any) => {
  const data = await axiosInstance({
    url: `/newsletter/${formData}`,
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

export function useNewsletter() {
  const fallback: any = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.newsletter],
    queryFn: () => getNewsletter(),
  });
  return data;
}

export function useCreateNewsletter() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => createNewsletter(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.newsletter]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

export function useUpdateNewsletter() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => updateNewsletter(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.newsletter]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

export function useDeleteNewsletter() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => deleteNewsletter(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.newsletter]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}
